<greco-user-browse-communities
  callToActionText="Select"
  selectedCallToActionText="Already Selected"
  [selectedCommunity]="selectedCommunityId"
  (communityClick)="selectedCommunityId = $event.id"
></greco-user-browse-communities>

<button mat-flat-button color="primary" style="width: 100%" (click)="confirm()">Confirm</button>
